const invertedMessages = {
  'Loading…': 'certs.prelaunch.detail.loading',
  'No records found.': 'certs.prelaunch.detail.empty',
};

export default invertedMessages;
